import { GatewayError } from '../gateway/GatewayClient';

export const REPLACED_SESSION_AUTO_CLOSE_MILLISECONDS = 10_000;

export const REPLACED_SESSION_MESSAGE =
  'You have logged in to a new account from the same computer or to this account from a different one. This session will be automatically closed in 10 seconds.';

type SessionTerminationTimers = Readonly<{
  setTimeout: (handler: () => void, delayMilliseconds: number) => number;
  clearTimeout: (timer: number) => void;
}>;

export class ReplacedSessionTermination {
  private timer: number | undefined;
  private finished = false;

  constructor(
    private readonly terminate: () => void,
    private readonly timers: SessionTerminationTimers = window,
  ) {}

  start(): void {
    if (this.timer !== undefined || this.finished) return;
    this.timer = this.timers.setTimeout(
      () => this.finish(),
      REPLACED_SESSION_AUTO_CLOSE_MILLISECONDS,
    );
  }

  dismiss(): void {
    this.finish();
  }

  private finish(): void {
    if (this.finished) return;
    this.finished = true;
    if (this.timer !== undefined) {
      this.timers.clearTimeout(this.timer);
      this.timer = undefined;
    }
    this.terminate();
  }
}

export function isReplacedSession(error: unknown): error is GatewayError {
  return error instanceof GatewayError && error.code === 'session_replaced';
}
